module.exports = __webpack_public_path__ + "media/images/chevron_down-475a17ce670d315bb43d76698d6ab041.svg";